
<ng-container [ngSwitch]="mode">

  <!--ADMIN-->
  <!--ACTIVE-->
  <ng-template [ngSwitchCase]="ModeQuestion.create">
    <ul class="dominoUl list-group list-group-flush" id="choix">
      <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of questElement.options ; let optionIndex = index">
        <div class="row item">
          <div class="QuestTransition col-12 col-md-9  px-1 py-2">
            <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" (ngModelChange)="generateGapOption(option,$event,optionIndex)" [(ngModel)]="option.text" />
          </div>
          <div class="col-3 col-md-2  px-1 py-2">
            <input class="form-control py-1" type="text" placeholder="{{'point' | trad}}" [(ngModel)]="option.point" (ngModelChange)="getMaxNote()" />
          </div>
          <button class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(option)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>
        </div>
        <div class="row  item">
          <div class="QuestTransition col-12 col-md-12  px-1 py-2">
            <a *ngFor="let word of option.text.split(' '),let i = index" (click)="selectWord(i,questElement,option,optionIndex)" [ngClass]="selectedWord(word)" class="gapFillWord"> {{word}}</a>
          </div>
        </div>

      </li>
    </ul>


    <div class="row mt-4 mb-2 item">
      <ul class="dominoUl">
        <li *ngFor="let proposal of gapsFillProposal" class="domino" placeholder="Ajouter un domino" #proposals>

          <i *ngIf="proposal.isAnswer" class="fas fa-bars"></i>
          <i *ngIf="!proposal.isAnswer" (click)="DeleteProposal(proposal.text)" class="fas fa-times"></i>
          <div>{{proposal.text}}</div>

        </li>
        <li class="waperAddDomino">
          <input class="form-control py-1 addDomino" [(ngModel)]="proposalToAdd" placeholder="Ajouter un domino" />
          <button class="btn  btn-circle q-hover" (click)="addProposal()" title="Ajouter un domino"><i class="fa fa-plus"></i></button>
        </li>
      </ul>
    </div>
  </ng-template>

  <!--NOT ACTIVE-->
  <ng-template [ngSwitchCase]="ModeQuestion.cDiplay">
    <div *ngFor="let option of questElement.options; let w = index ; let first = first" class="questElement.mediaOption?'col-md-6 px-1':'col-md-12 px-1'">
      <div class="row pl-5 pt-2 pb-2">
        <ng-template ngFor let-i="index" let-word [ngForOf]="option.text.split(' ')">

          <div *ngIf="word.includes('[') && word.includes(']')">
            <input class="gapWord" type="text" [(ngModel)]="option.gapsFill[i].answer" />
          </div>
          <a class="gapWord" *ngIf="!(word.includes('[') && word.includes(']'))">{{word}}</a>
        </ng-template>
      </div>
    </div>
    <div class="row item mt-4">
      <ul class="dominoUl">
        <li class="domino" *ngFor="let proposal of gapsFillProposal"><i class="fas fa-bars"></i> <div>{{proposal.text}}</div></li>
      </ul>
    </div>
  </ng-template>



  <!--REPONSE-->
  <ng-template [ngSwitchCase]="ModeQuestion.reply">
    <div *ngFor="let option of questElement.options; let w = index ; let first = first" class="questElement.mediaOption?'col-md-6 px-1':'col-md-12 px-1'">
      <div class="row pl-5 pt-2 pb-2">
        <ng-template ngFor let-i="index" let-word [ngForOf]="option.text.split(' ')">

          <div *ngIf="word.includes('[') && word.includes(']')">
            <input id="{{w}}|{{i}}" class="gapWord" type="text" [(ngModel)]="option.gapsFill[i].answer" disabled #dropZones />
          </div>
          <a class="gapWord" *ngIf="!(word.includes('[') && word.includes(']'))">{{word}}</a>
        </ng-template>
      </div>
    </div>
    <div class="row item mt-4">
      <ul class="dominoUl">
        <li class="domino" *ngFor="let proposal of gapsFillProposal" [attr.domino]="proposal.text" draggable="true" #dominos><i class="fas fa-bars"></i> <div>{{proposal.text}}</div></li>
      </ul>
    </div>
  </ng-template>


  <ng-template [ngSwitchCase]="ModeQuestion.rDiplay">
    <div *ngFor="let option of questElement.options; let w = index ; let first = first" class="questElement.mediaOption?'col-md-6 px-1':'col-md-12 px-1'">
      <div class="row pl-5 pt-2 pb-2">
        <ng-template ngFor let-i="index" let-word [ngForOf]="option.text.split(' ')">
          <div *ngIf="word.includes('[') && word.includes(']')">
            <input disable *ngIf="option.gapsFill[i].isCorrect" class="gapWord gapCorrect" type="text" [(ngModel)]="option.gapsFill[i].answer" />
            <input disable *ngIf="!option.gapsFill[i].isCorrect" class="gapWord gapIncorrect" type="text" [(ngModel)]="option.gapsFill[i].answer" />
          </div>
          <a class="gapWord" *ngIf="!(word.includes('[') && word.includes(']'))">{{word}}</a>
        </ng-template>
      </div>
      <div class="row pl-5 mb-4">
        <ng-template ngFor let-i="index" let-word [ngForOf]="option.text.split(' ')">
          <a class="gapWord" [ngClass]="{'q-c-success':option.gapsFill[i].isCorrect ,'q-c-danger':!option.gapsFill[i].isCorrect}" *ngIf="word.includes('[') && word.includes(']')">{{option.gapsFill[i].text}}</a>
          <a class="gapWord" *ngIf="!(word.includes('[') && word.includes(']'))">{{word}}</a>
        </ng-template>
      </div>
    </div>

  </ng-template>

</ng-container>

